import { createModel, RematchDispatch } from '@rematch/core';
import { POI_TYPE } from '../../../commons/constants/constants';
import { PoiData, PoiPolygonData } from '../../../types/PoiData';
import { RootModel } from '../../models';

export const storeName = 'configTourModal';

const initialValues = {
  visible: false,
  hidePoiEditor: false,
  editPoi: null,
  previewedPoi: null,
  activeScene: null,
  startingScene: null,
  drawingPolygon: false,

  globalConfigVisible: false,

  previewing: false,
  previewingScene: null,
  prevScene: null,
  skinLayerVisible: true,
  poiCodes: [],
  visibleModalCloneHotspot: false,
  visibleSceneListModal: false,
};

export const configTourModal: any = createModel<RootModel>()({
  state: { ...initialValues }, // initial state
  reducers: {
    setPreviewedPoi(state, payload: PoiData) {
      return {
        ...state,
        previewedPoi: payload,
      };
    },
    setEditPoi(state, payload: PoiData) {
      const { visibleConfig } = payload || {};
      let drawingPolygon = false;
      if (payload && payload.type === POI_TYPE.POLYGON) {
        const polygonalPoi = payload as PoiPolygonData;
        const { points = [] } = polygonalPoi;
        if (points.length === 0) {
          drawingPolygon = true;
        }
      }

      return {
        ...state,
        editPoi: payload,
        visible: visibleConfig || false,
        drawingPolygon,
      };
    },
    showConfigModal(state, payload = true) {
      return {
        ...state,
        visible: payload,
      };
    },
    setActiveScene(state, payload) {
      return {
        ...state,
        activeScene: payload,
      };
    },
    setVisible(state, payload) {
      return {
        ...state,
        visible: payload,
      };
    },
    setStartingScene(state, payload) {
      return {
        ...state,
        startingScene: payload,
      };
    },
    setDrawingPolygon(state, payload) {
      return {
        ...state,
        drawingPolygon: payload,
      };
    },
    setGlobalConfigVisible(state, payload) {
      return {
        ...state,
        globalConfigVisible: payload,
      };
    },
    setPreviewing(state, payload) {
      return {
        ...state,
        previewing: payload,
      };
    },
    setPreviewingScene(state, payload) {
      return {
        ...state,
        previewingScene: payload,
      };
    },
    setPrevScene(state, payload) {
      return {
        ...state,
        prevScene: payload,
      };
    },
    setSkinLayerVisible(state, payload) {
      return {
        ...state,
        skinLayerVisible: payload,
      };
    },
    setPoiCodes(state, payload) {
      return {
        ...state,
        poiCodes: payload,
      };
    },
    setVisibleCloneHotspot(state, payload) {
      return {
        ...state,
        visibleModalCloneHotspot: payload || initialValues.visibleModalCloneHotspot,
      };
    },
    reset(state) {
      return {
        ...state,
        ...initialValues,
      };
    },
    setVisibleSceneListModal(state, payload) {
      return {
        ...state,
        visibleSceneListModal: payload,
      };
    },
  },
  effects: (dispatch: RematchDispatch<typeof configTourModal>) => ({
    async startPreviewing(payload, state) {
      this.setPreviewingScene(payload.previewingScene);
      this.setPrevScene(payload.currentScene);
      await this.setPreviewing(true);
      this.setSkinLayerVisible(false);
      this.setGlobalConfigVisible(false);
    },
    async stopPreviewing(payload, state) {
      this.setPreviewingScene(null);
      this.setPrevScene(null);
      this.setSkinLayerVisible(true);
      await this.setGlobalConfigVisible(true);
      this.setPreviewing(false);
    },
    updatePoiCodes(payload, state) {
      const { poiCodes } = state.configTourModal;

      if (!payload) {
        this.setPoiCodes(initialValues.poiCodes);
        return;
      }
      const listPoiCode = [...poiCodes];
      if (listPoiCode.indexOf(payload) === -1) {
        listPoiCode.push(payload);
      } else {
        listPoiCode.splice(listPoiCode.indexOf(payload), 1);
      }
      this.setPoiCodes(listPoiCode);
    },
    submitCloneHotspot(payload, state) {
      this.setVisibleCloneHotspot(false);
      this.setActiveScene(payload);
      this.setPoiCodes(initialValues.poiCodes);
    },
  }),
});
export default configTourModal;
